import { render } from "./PosTimeNotifications.vue?vue&type=template&id=afbab016&scoped=true"
import script from "./PosTimeNotifications.vue?vue&type=script&lang=js"
export * from "./PosTimeNotifications.vue?vue&type=script&lang=js"

import "./PosTimeNotifications.vue?vue&type=style&index=0&id=afbab016&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afbab016"]])

export default __exports__